
import React,{ useEffect } from 'react';
import Cookies from 'universal-cookie';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DatePicker, MuiPickersUtilsProvider , KeyboardDatePicker} from "@material-ui/pickers";
// import { DateField } from '@mui/x-date-pickers';
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/he";
import Box from '@material-ui/core/Box';
import FormGroup from '@material-ui/core/FormGroup';
import  { Redirect } from 'react-router-dom'

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
// import Menu from '@material-ui/core/Menu';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
// import FlagIcon from '@material-ui/icons/Flag';
// import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import cyan from '@material-ui/core/colors/cyan';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
import { useHistory } from "react-router-dom";
import validator from 'validator'

// import red from '@material-ui/core/colors/red';
import axios from 'axios';
// import ReactToPrint from 'react-to-print';
import './Label.css';
import Header from './Header'
const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  '@global':{
    body:{
      backgroundColor:"#e2dedf",
    }
  },
  title: {

  },
  subTitle:{
    fontWeight: "normal"
  },
  root: {
    backgroundColor:"#e2dedf",
    flexGrow: 1,
    padding: theme.spacing(2),

    textAlign: 'center',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      // width: '40ch',
    },
    '&$required': {
      color: 'white'
    }
  },
  textField: {
    fontSize: 50, //works!

    '& p':{
      color: red[600],
    }
  },
      formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuButton: {
    marginLeft: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing(1)
  },
  paper: {
    backgroundColor:"#e2dedf",
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  busy: {
    textAlign: 'center',
    padding: theme.spacing(2),
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  }
}));
const theme = createMuiTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: pink[400],
    },
    secondary: {
      main: pink[200],
    },
    inherit: {
      main: cyan[200],
    },
  },
});
export default function Card() {
  

  // const API_URL = "http://37.139.28.173:5000"
  const API_URL = "https://gw-club.euro-sport.co.il"
  const classes = useStyles();
  const [fullName, setFullName] = React.useState('');
  const [nameError, setNameError] = React.useState('');
  const [id, setId] = React.useState(null);
  const [idError, setIdError] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [date, setDate] = React.useState(null);
  const [gender, setGender] = React.useState('');
  const [agrement, setAgrement] = React.useState(false);
  const [started, setStarted] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  // const hash = new URLSearchParams(this.props.location.search).get("__firebase_request_key")
  
  useEffect(() => { 
    axios.post(API_URL+'/get_invention',{
      token:window.location.pathname
    })
    .then(function (response) {
      if(response.status === 200){
        console.log(response.data.data)
        setPhone(response.data.data)
      }
      else{
        setPhone(404)

      }
    })
    .catch(function (error) {
    });

  }, [])
  const checkName = (value) => {
    if( value && !/\s/.test(value)){
      setNameError("שם לא חוקי. חסר שם משפחה?")
    }
    else{
      setNameError("")
    }
    // else if(!value){
    //   setNameError("שדה חובה")
    // }
  }
  const checkId = (value) => {
    // accept only digits, dashes or spaces
        if (/[^0-9-\s]+/.test(value)) return false;
    
    // The Luhn Algorithm. It's so pretty.
        var nCheck = 0, nDigit = 0, bEven = false;
        value = value.replace(/\D/g, "");
    
        for (let n = value.length - 1; n >= 0; n--) {
            let cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);
    
            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }
    
            nCheck += nDigit;
            bEven = !bEven;
        }
    
        return (nCheck % 10) == 0;
    }
  const handleStart = (event) => {
    setStarted(true)
    if (validateInputs()){
      setBusy(true)
      axios.post(API_URL+'/submit_customer',{
        customerName: fullName.replaceAll('"',"").replaceAll("'",""),
        customerId: id,
        customerPhone: phone,
        customerEmail: email,
        customerSex: gender,
        customerBirth: date
      })
      .then(function (response) {
        if(response.status === 200){
          window.location.href = "/success";
        }
        else{
          window.location.href = "/failed";
        }

      })
      .catch(function (error) {
        setBusy(false)
      });
      setBusy(false)

    }
    // axios.post(API_URL+'/new_invite_sms',{
    //   agent:worker.id,phone:phone
    // })
    // .then(function (response) {

    // })
    // .catch(function (error) {
    //     console.log(error);
    // });
    // setDetails(event.target.checked);
  };
  const handleCancel = (event) => {
    // setPhone('')
    setFullName('')
    setId('')
    setDate(null)
    setEmail('')
    setGender('')
    setAgrement(false)
  }
  const validateInputs = () => {
    if(fullName && id && agrement){
      return true;
    }
    else {

      if(!fullName){
        setNameError('שדה חובה')
      }
      if(!id){
        setIdError('שדה חובה')
      }
      // if(!email){
      //   setEmailError('שדה חובה')
      // }
    }
  }
    const handleInput = (event) => {
      switch(event.target.id){
        case 'fullName':
          // checkName(event.target.value)
          setFullName(event.target.value)
        break;
        case 'id':
          if(checkId(event.target.value)){
            setIdError('')
          }
          else{
            setIdError('מספר תעודת זהות אינו תקין')
          }
          setId(event.target.value)
          break;
        case 'phone':
          setPhone(event.target.value)
        break;
        case 'email':
          setEmail(event.target.value)
          if (validator.isEmail(event.target.value) || event.target.value == "1212") {
            setEmailError("")
          }
          else{
            setEmailError("כתובת האימייל לא תקינה")
          }
        break;
        case 'gender':
          setGender(event.target.value)
        break;
        case 'agrement':
          setAgrement(!agrement)
        break;
      }
      if(event.target.value === "men" || event.target.value === "women"){
          setGender(event.target.value)
      }
        // setPhone(event.target.value)
    }

  return (
    <ThemeProvider theme={theme}>
    <div className={classes.root}>
      <img src='logo.png' height='40px'/>
            {
            phone !== 404 && (
            <form className={classes.root} autoComplete="off">
              <h3 className={classes.title}>הגיע הזמן שנהיה חברים</h3>
              <h4 className={classes.subTitle}>רק עוד כמה פרטים וההטבות לקניה הראשונה בדרך אליך!</h4>
                <div>
                  <TextField id="fullName" type="text" className={classes.textField}  label="שם מלא" required={true} helperText={nameError} value={fullName} onChange={(e) => handleInput(e, 'fullName')}/>
                </div>
                <div>
                  <TextField id="id" type="number" className={classes.textField} label="תעודת זהות" helperText={idError} required={true}  value={id} onChange={handleInput}/>
                </div>
                <div>
                  <TextField id="phone" type="number" disabled={true} value={phone} label="מספר טלפון" required={true} onChange={handleInput}/>
                </div>
                <div>
                  <TextField id="email" className={classes.textField} type="text"  value={email} label="אימייל" onChange={handleInput} helperText={emailError} />
                </div>
                <div>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"he"} >
                  <KeyboardDatePicker
                    label="תאריך לידה"
                    format="L"
                    clearable
                    okLabel="אישור"
                    clearLabel="ניקוי"
                    cancelLabel="ביטול"
                    value={date}
                    variant="dialog"
                    maxDateMessage=""
                    mask="__/__/____"
                    placeholder="dd/MM/yyyy"
                    onChange={(dateChanged) => setDate(dateChanged)}
                    views={["year", "month", "date"]}
                    invalidDateMessage="תאריך לא תקין. נדרש שנה/חודש/יום"
                  />
                </MuiPickersUtilsProvider>
                </div>
                <div>

                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-outlined-label">מגדר</InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="gender"
                    value={gender}
                    onChange={handleInput}
                    label="מגדר"
                  >
                    <MenuItem value={'men'}>זכר</MenuItem>
                    <MenuItem value={'women'}>נקבה</MenuItem>
                  </Select>
                </FormControl>
                </div>
<FormControl error={!agrement && started} >
  <FormControlLabel
                      control={<Checkbox id="agrement"  color='primary' checked={agrement} name="checkedA" onChange={handleInput} />}
                      label='הנני מאשר/ת את תקנון ההצטרפות למועדון הלקוחות וקבלת מבצעים וחומר שיווקי במייל ובסמס מיורוספורט בע"מ. מתחייבים שלא להעביר את פרטיך לצד שלישי'/>
  {!agrement && started && <FormHelperText>עלייך לאשר את התקנון</FormHelperText>}
</FormControl>

                {/* <div><TextField id="outlined-basic" type="number" InputLabelProps={{ shrink: true }} label="מגדר" required={true} onChange={handleInput}/></div> */}
                {phone && ([
                // {fullName && phone && agrement && checkId(id) && validator.isEmail(email) && ([
                  <div>     
                    <Button variant="contained" color="primary" className={classes.button} disabled={busy} onClick={handleStart}>שלח</Button>
                  </div>
                 ])}
            </form>
            )}
            {phone === 404 && (<div>חבר מועדון לא נמצא. יש לפנות לשירות הלקוחות</div>)}
        {/* </Paper> */}
        
    </div>
        {/* </div> */}

  </ThemeProvider>
  );
}
